var map = {
	"./BardBotSettings": 4726,
	"./BardBotSettings.vue": 4726,
	"./BingChatBotSettings": 1197,
	"./BingChatBotSettings.vue": 1197,
	"./ChatGPTBotSettings": 2312,
	"./ChatGPTBotSettings.vue": 2312,
	"./GradioAppBotSettings": 4117,
	"./GradioAppBotSettings.vue": 4117,
	"./HuggingChatBotSettings": 4630,
	"./HuggingChatBotSettings.vue": 4630,
	"./LMSYSBotSettings": 5073,
	"./LMSYSBotSettings.vue": 5073,
	"./LoginSetting": 1863,
	"./LoginSetting.vue": 1863,
	"./MOSSBotSettings": 1287,
	"./MOSSBotSettings.vue": 1287,
	"./OpenAIAPIBotSettings": 7528,
	"./OpenAIAPIBotSettings.vue": 7528,
	"./SparkBotSettings": 2008,
	"./SparkBotSettings.vue": 2008,
	"./WenxinQianfanBotSettings": 2911,
	"./WenxinQianfanBotSettings.vue": 2911
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2124;
module.exports = webpackAsyncContext;